"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function viewSL() {
    return {
        constructor: function (props) {
        },
        mounted: function () {
        },
        events: {
            onApplyClick: this.props.onApplyClick,
            onSaveClick: this.props.onSaveClick,
            onShareClick: this.props.onShareClick,
            setContentHeight: this.props.setContentHeight
        }
    };
}
exports.viewSL = viewSL;



//////////////////
// WEBPACK FOOTER
// C:/WS/ls/build/player-career-site/src/.tmp/JobDetailsBannerContent/ViewSL.js
// module id = 787
// module chunks = 0